// extracted by css-extract-rspack-plugin
export default {"file-tree-row":"DiffFileTree-module__file-tree-row__bz7o_Kr"};